import { useEffect } from 'react'

import { Redirect } from 'react-router'

import { MemberStatus } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { useAuthMember } from '@tribeplatform/react-sdk/hooks'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { useQuery } from '../../lib/useQuery'
import { useResendVerificationCode } from './hooks/useResendVerificationCode'
import { VerifyForm } from './VerifyForm'

/**
 * query-@param memberId to check whether user is verified already or not (Optional)
 * query-@param resend to resend the verification code on component did mount (Optional)
 * @returns Verify Page
 */
export const Verify = () => {
  const { data: member } = useAuthMember()
  const { onResend } = useResendVerificationCode()
  const queryParams = useQuery<{ memberId?: string; resend?: 'true' }>()
  const { resend: resendQuery } = queryParams
  const { memberId: memberIdQuery } = queryParams

  useEffect(() => {
    if (resendQuery === 'true') {
      onResend()
    }
  }, [])

  if (member && member.status === MemberStatus.VERIFIED) {
    return <Redirect to="/" />
  }

  const memberId = memberIdQuery ?? member?.id
  if (!memberId || memberId.startsWith('GUEST_')) {
    return <Redirect to="/auth/login" />
  }

  return (
    <>
      <div className="lg:w-1/2 md:w-full flex mx-auto flex-col py-8 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-content-on-background">
            <T
              defaultMessage="Please verify your account"
              id="Auth.VerifyAccount.Title"
            />
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <Card>
            <Card.Content>
              <VerifyForm memberId={memberId} />
            </Card.Content>
          </Card>
        </div>
      </div>
    </>
  )
}
